export default "__VITE_ASSET__BJHcfzbi__"